import React, { Suspense, useContext } from "react";
import DynamicLayout from "../../components/DynamicLayout";
import { PlatformContext } from "../../context/PlatformContext";
import { getPlatformComponent, LoadingComponent } from "../../helpers/platformUtils";

const wallpaperStyle = {
  backgroundImage: `url('/img/saturnwallpaper.jpg')`,
};

const PlatformToolPage = ({ componentKey, withWallpaper = true }) => {
  const { platform, loading } = useContext(PlatformContext);
  const isMobile = platform === "mobileApp" || platform === "mobileWeb";
  const ToolComponent = getPlatformComponent(componentKey, isMobile);

  if (loading || !ToolComponent) {
    return (
      <DynamicLayout>
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const content = (
    <Suspense fallback={<LoadingComponent />}>
      <ToolComponent />
    </Suspense>
  );

  return (
    <DynamicLayout>
      {!isMobile && withWallpaper ? (
        <div className="full-screen-image-container margin-top-0" style={wallpaperStyle}>
          {content}
        </div>
      ) : (
        content
      )}
    </DynamicLayout>
  );
};

export default PlatformToolPage;
